/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingpublishinstagram2Inputs */

const en_crosspostingpublishinstagram2 = /** @type {(inputs: Crosspostingpublishinstagram2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish to Instagram`)
};

const de_crosspostingpublishinstagram2 = /** @type {(inputs: Crosspostingpublishinstagram2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Instagram veröffentlichen`)
};

/**
* | output |
* | --- |
* | "Publish to Instagram" |
*
* @param {Crosspostingpublishinstagram2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingpublishinstagram2 = /** @type {((inputs?: Crosspostingpublishinstagram2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingpublishinstagram2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingpublishinstagram2(inputs)
	return de_crosspostingpublishinstagram2(inputs)
});
export { crosspostingpublishinstagram2 as "crosspostingPublishInstagram" }